<template>
  <div class="mydialog">
    <div class="page_title">成药审核</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item
                index="1"
                class="title"
                style="font-size: 16px"
              >待审核</el-menu-item>
              <el-menu-item
                index="2,3"
                class="title space"
                style="font-size: 16px"
              >已审核</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div
              class="searchbox"
              style="text-align: left"
            >
              <div class="item">
                <span>药房名称</span>
                <!-- <el-input
                  v-model="hospital_name"
                  style="width: 130px; margin: 0 14px 0 6px"
                  @input="search"
                  clearable
                ></el-input> -->
              <myInputSerch v-model="hospital_name" @update="search" style="margin:0 10px 0 10px;"></myInputSerch>

              </div>
              <div class="item">
                <span>成药名称</span>
                <el-input
                  v-model="pm_name"
                  style="width: 130px; margin: 0 14px 0 6px"
                  @input="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>疗效分类</span>
                <el-input
                  v-model="category_name"
                  style="width: 130px; margin: 0 14px 0 6px"
                  @input="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>成药分类</span>
                <el-radio-group
                  v-model="pm_category"
                  style="margin: 0 14px 0 6px"
                  @change="search"
                >
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">西药</el-radio>
                  <el-radio :label="2">中成药</el-radio>
                </el-radio-group>
              </div>
              <div class="item">
                <span>提交时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 225px; margin: 0 12px"
                  @change="search"
                ></el-date-picker>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-right: 15px;
                  "
                  @click="search"
                >查询</el-button>
                <el-button
                  type="primary"
                  @click="examineAll"
                  style="width: 120px; margin-left: auto"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('568')
                      : false
                  "
                  v-show="active == 1"
                >批量审核</el-button>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
                @sort-change="changeOrder"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                  label="药房名称"
                  prop="hospital_name"
                  sortable="custom"
                ></el-table-column>
                <el-table-column
                  label="成药名称"
                  prop="pm_name"
                ></el-table-column>
                <el-table-column label="成药分类">
                  <template slot-scope="scope">
                    <div v-if="scope.row.pm_category == 1">西药</div>
                    <div v-if="scope.row.pm_category == 2">中成药</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="疗效分类"
                  prop="category_name"
                ></el-table-column>
                <el-table-column
                  label="规格"
                  prop="pm_spec"
                ></el-table-column>
                <el-table-column
                  label="单位"
                  prop="pm_unit"
                ></el-table-column>
                <el-table-column
                  label="成本价"
                  prop="cost_price"
                ></el-table-column>
                <el-table-column
                  label="销售价"
                  prop="price"
                ></el-table-column>
                <el-table-column
                  label="生产厂家"
                  prop="productor"
                ></el-table-column>
                <el-table-column
                  label="提交时间"
                  prop="update_time"
                  sortable="custom"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.update_date }}</div>
                    <div>{{ scope.row.update_time }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="审核状态"
                  v-if="active == '2,3'"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.reviewed_status == 2">通过</span>
                    <span
                      style="color: #f24b2f"
                      v-if="scope.row.reviewed_status == 3"
                    >不通过</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.pm_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('567')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.reviewed_status == 1"
                      @click="examine(scope.row.pm_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('568')
                          : false
                      "
                    >审核</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from '@/components/myInputSerch';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
export default {
  components: {
    myInputSerch
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      Selection: [],
      activeIndex: '1',
      active: 1,
      hospital_name: '',
      pm_name: '',
      pm_category: '',
      category_name: '',
      date: [],
      orderby: 0
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取审核列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        pm_name: this.pm_name,
        pm_category: this.pm_category,
        category_name: this.category_name,
        auth_status: this.active,
        orderby: this.orderby
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/TraditionDrug/getTraditionDrugAuthList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.update_date = platform.timestampToDate(item.update_time);
              item.update_time = platform.timestampTohour(item.update_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;

      //升序
      if (order == 'ascending') {
        if (prop == 'hospital_name') {
          this.orderby = 1;
        } else if (prop == 'update_time') {
          this.orderby = 3;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'hospital_name') {
          this.orderby = 2;
        } else if (prop == 'update_time') {
          this.orderby = 4;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    handleSelect(key, keyPath) {
      // this.hospital_name = '';
      this.pm_name = '';
      this.active = key;
      this.currentPage = 1;
      this.pagesize = 10;
      this.date = [];
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      this.Selection = val;
    },
    //成药详情
    toDetail(pm_id) {
      this.$router.push({ path: 'chengyaodetail', query: { pm_id } });
    },
    //审核
    examine(pm_id) {
      this.$confirm('是否审核通过？', '审核', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过'
      })
        .then(() => {
          let auth_status = 2;
          let data = { pm_id, auth_status };
          this.axios
            .post('platform/TraditionDrug/auditTraditionDrug', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('该成药审核通过!');
              }
              this.getList();
            });
        })
        .catch((action) => {
          if (action === 'cancel') {
            let auth_status = 3;
            let data = { pm_id, auth_status };
            this.axios
              .post('platform/TraditionDrug/auditTraditionDrug', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.error('该成药审核未通过!');
                }
                this.getList();
              });
          }
        });
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.pm_id;
      });
      let pm_id = selectId.toString();
      this.examine(pm_id);
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .item {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}
.mydialog .mydia .el-dialog {
  border-radius: 5px;
}
.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>